import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

function Contact() {
  const emailAddress = 'N190487@rguktn.ac.in';
  const mailtoUrl = `mailto:${emailAddress}`;
  return (
    <div className=' mt-5' style={{paddingTop:"20px",paddingBottom:"100px"}} id="contact" data-aos="fade-up">
      <center>
      <h2 className='text-white mb-3'><span className='color'>04. &nbsp; &nbsp;</span>Get In Touch</h2>
      <p className='color mb-3'>What's next</p>
     
      <Row>
        <Col>
        </Col>
        <Col lg={8}>
          <p className="font2 color2 mb-5"> My inbox is always open. Whether you have a question or just want to say hi, <br/> I'll try my best to get back to you!</p>
        </Col>
        <Col></Col>
      </Row>
      <a href={mailtoUrl}>    <Button className=" gap but1 rounded-pill py-3 px-5 font2 mb-5" variant="outline-info"   style={{ "fontWeight": "700" }}>Say Hello!</Button> </a>
      </center>
    </div>
  )
}

export default Contact
